import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Form, Card, CardBody } from "react-bootstrap";
import home from "../../../assets/images/life-insurance/property-details.svg";
import location from "../../../assets/images/life-insurance/location-details.svg";
import coverageOptions from "../../../assets/images/life-insurance/coverage-options.svg";
import security from "../../../assets/images/life-insurance/owner-security.svg";
import policy from "../../../assets/images/life-insurance/policy-preferences.svg";
import { jsPDF } from "jspdf";
import Logo from "../../../assets/images/life-insurance/logo.png";
import "./home-insurance.scss";
import NoIndexSEO from "../../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../../utils/seoConfig";
// import { ReactComponent as CommingSoonIcon } from "../../../assets/images/comming-soon.svg";
import {
  getAllCities,
  getAllStates,
  getViewProfile,
} from "../../../redux/slices/profileSlice";
import {
  createHomeInsurance,
  downloadHomePDF,
} from "../../../redux/slices/homeInsuranceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ReactComponent as FiSliders } from "../../../assets/images/filters-icon.svg";
import { ReactComponent as Save } from "../../../assets/images/save.svg";
import { ReactComponent as Download } from "../../../assets/images/download.svg";
import { ReactComponent as Mail } from "../../../assets/images/mail.svg";
import { ReactComponent as Submit } from "../../../assets/images/submit.svg";
import {
  activityEnd,
  activityStart,
} from "../../../redux/slices/trackActivitySlice";
import usePageTracking from "../../../hooks/usePageTracking";
import { calculatorAnalytics } from "../../../redux/slices/lifeinsuranceSlice";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";
import PaywallSheet from "../../../components/PaywallSheet";

const HomeInsurance = ({
  formatCurrency = (val) => `$${Number(val).toLocaleString()}`,
}) => {
  const [localCities, setLocalCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  const planSlug = store?.profileItem?.data?.plan?.name?.toLowerCase();
  const homeStore = useSelector((state) => state.homeInsurance);
  const authStore = useSelector((state) => state.auth);
  const [showFilters, setShowFilters] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [userEmail, setUserEmail] = useState("  ");
  const analyticsDebounceRef = React.useRef({});
  const hasRestoredFromLocalStorage = React.useRef(false);
  
  // Collapsible sections state
  const [expandedSections, setExpandedSections] = useState({
    property: true,
    location: false,
    coverage: false,
    security: false,
    policy: false,
  });
  
  const [showBreakdown, setShowBreakdown] = useState(false);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  useEffect(() => {
    const userProfileEmail = async () => {
      if (!store.profileItem?.data) {
        const data = await dispatch(getViewProfile());
        const email = data.payload?.profileItem?.data.email;
        console.log("EmailDispatched", email);
        setUserEmail(email);
        return;
      }
      const email = store.profileItem?.data.email;
      setUserEmail(email);
    };

    userProfileEmail();
  }, [store.profileItem?.data]);

  usePageTracking("HOME_INSURANCE_CALCULATOR");

  useEffect(() => {
    const payload = {
      page_name: "HOME_INSURANCE_CALCULATOR",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "HOME_INSURANCE_CALCULATOR",
        }),
      );
    };
  }, [dispatch]);


  

  const HomeInsuranceSchema = Yup.object().shape({
    homeValue: Yup.number()
      .required("Home value is required")
      .min(10000, "Minimum home value is $10,000"),

    homeType: Yup.string()
      .oneOf(
        ["Apartment", "Condo", "Detached", "Townhouse"],
        "Select a valid home type",
      )
      .required("Home type is required"),

    homeSize: Yup.number()
      .required("Home size is required")
      .min(100, "Size must be at least 100 sq ft"),

    yearBuilt: Yup.number()
      .required("Year built is required")
      .min(1800, "Year must be 1800 or newer"),
    // .max(2025, "Year must be 2025 or older"),

    constructionType: Yup.string()
      .oneOf(
        ["Wood", "Brick", "Concrete", "Steel"],
        "Select a valid construction type",
      )
      .required("Construction type is required"),

    state: Yup.string().required("State is required"),

    city: Yup.string().required("City is required"),

    floodZone: Yup.string()
      .oneOf(["yes", "no"], "Select flood zone")
      .required("Flood zone is required"),

    earthquakeZone: Yup.string()
      .oneOf(["yes", "no"], "Select earthquake zone")
      .required("Earthquake zone is required"),

    crimeRisk: Yup.string()
      .oneOf(["Low", "Medium", "High"], "Select crime risk level")
      .required("Crime risk level is required"),

    coverageAmount: Yup.number()
      .required("Coverage amount is required")
      .min(10000, "Coverage minimum is $10,000"),

    personalPropertyCoverage: Yup.string()
      .oneOf(["yes", "no"], "Select personal property coverage")
      .required("Personal property coverage is required"),

    naturalDisasterCoverage: Yup.string()
      .oneOf(["yes", "no"], "Select natural disaster coverage")
      .required("Natural disaster coverage is required"),

    occupancyType: Yup.string()
      .oneOf(["Owner-occupied", "Rental"], "Select occupancy type")
      .required("Occupancy type is required"),

    securitySystem: Yup.string()
      .oneOf(["yes", "no"], "Select security system option")
      .required("Security system is required"),

    smokeAlarms: Yup.string()
      .oneOf(["yes", "no"], "Select smoke alarm preference")
      .required("Smoke alarms preference is required"),

    claimsHistory: Yup.number()
      .required("Claims history required")
      .min(0, "Min 0 claims"),
    // .max(10, "Max 10 claims allowed"),

    deductible: Yup.number().required("Deductible is required"),

    liabilityCoverage: Yup.number().required("Liability coverage is required"),

    paymentFrequency: Yup.string()
      .oneOf(["Monthly", "Annual"], "Select payment frequency")
      .required("Payment frequency is required"),

    coverageTerm: Yup.string().required("Coverage term is required"),
  });

  const form = useForm({
    resolver: yupResolver(HomeInsuranceSchema),
    mode: "onChange",
    defaultValues: {
      homeValue: "",
      homeType: "Apartment",
      homeSize: "",
      yearBuilt: "",
      constructionType: "Wood",
      state: "",
      city: "",
      postalCode: "",
      floodZone: "no",
      earthquakeZone: "no",
      crimeRisk: "Low",
      coverageAmount: "",
      deductible: 500,
      personalPropertyCoverage: "no",
      liabilityCoverage: 100000,
      naturalDisasterCoverage: "no",
      occupancyType: "Owner-occupied",
      securitySystem: "no",
      smokeAlarms: "no",
      claimsHistory: 0,
      paymentFrequency: "Monthly",
      coverageTerm: "1",
      addOns: [],
    },
  });

  // then destructure what you need
  const {
    register,
    setValue,
    formState: { errors },
  } = form;

  // now this works
  const watchedValues = useWatch({ control: form.control });

  useEffect(() => {
    setInputs(watchedValues);
  }, [watchedValues]);

  useEffect(() => {
    const profile = store?.profileItem?.data;
    if (profile) {
      setLocalCities({
        current: {
          state: {
            value: profile?.living_state ? profile?.living_state : "",
            label: profile?.living_state_name || "",
            code: profile?.living_state || "",
          },
          city: {
            value: profile?.city || "",
            label: profile?.city || "",
          },
        },
        destination: {
          state: {
            value: profile?.work_state ? profile?.work_state : "",
            label: profile?.work_state_name || "",
            code: profile?.work_state || "",
          },
          city: {
            value: profile?.work_city || "",
            label: profile?.work_city || "",
          },
        },
      });
    }
  }, [store?.profileItem]);

  useEffect(() => {
    dispatch(getAllStates());
  }, [dispatch]);

  useEffect(() => {
    if (localCities?.current?.state?.code) {
      dispatch(
        getAllCities({
          search_state: localCities.current.state.code,
        }),
      );
    }
  }, [dispatch, localCities?.current?.state?.code]);

  useEffect(() => {
    if (localCities?.destination?.state?.code) {
      dispatch(
        getAllCities({
          search_state: localCities.destination.state.code,
        }),
      );
    }
  }, [dispatch, localCities?.destination?.state?.code]);

  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store?.stateItems?.data?.states?.map((state) => ({
        value: state.id,
        label: state.state_full_name,
        code: state.state,
      }));
      setStateOptions(options);
    }
    if (store?.cityItems?.data?.cities) {
      const options = store.cityItems.data.cities.map((cityObj, index) => ({
        value: cityObj.city,
        label: cityObj.city,
      }));
      setCityOptions(options);
    }
  }, [store?.stateItems, store?.cityItems]);

  useEffect(() => {
    // Only restore from localStorage once on initial mount
    if (hasRestoredFromLocalStorage.current) return;
    
    const saved = JSON.parse(localStorage.getItem("HomeInsurenceInputs"));
    if (!saved || !stateOptions.length) return;

    // Mark that we've restored
    hasRestoredFromLocalStorage.current = true;

    // 1️⃣ Restore form values into react-hook-form
    Object.entries(saved).forEach(([key, value]) => {
      setValue(key, value, { shouldValidate: false });
    });

    // 2️⃣ Restore local inputs state
    setInputs(saved);

    // 3️⃣ Restore State properly
    const matchedState = stateOptions.find((s) => s.code === saved.state);

    if (matchedState) {
      setLocalCities((prev) => ({
        ...prev,
        destination: {
          state: matchedState,
          city: saved.city || null,
        },
      }));
    }
  }, [stateOptions, setValue]);

  const saved = JSON.parse(localStorage.getItem("HomeInsurenceInputs"));

  const [inputs, setInputs] = useState(
    saved || {
      homeValue: 10000,
      homeType: "",
      homeSize: "",
      yearBuilt: "",
      constructionType: "",
      location: "",
      state: "",
      city: "",
      postalCode: "",
      floodZone: "",
      earthquakeZone: "",
      crimeRisk: "",
      coverageAmount: "",
      deductible: "",
      personalPropertyCoverage: "",
      liabilityCoverage: "",
      naturalDisasterCoverage: "",
      occupancyType: "",
      securitySystem: "",
      smokeAlarms: "",
      claimsHistory: "",
      paymentFrequency: "Monthly",
      coverageTerm: "1",
      addOns: [],
    },
  );

  useEffect(() => {
    if (!inputs) return;

    // List only the fields that MUST be filled before API call
    // Note: zipCode is excluded from required fields since not all cities have zip codes in the database
    const requiredFields = [
      inputs?.homeValue,
      inputs?.homeType,
      inputs?.homeSize,
      inputs?.yearBuilt,
      inputs?.constructionType,
      inputs?.state || localCities?.destination?.state?.code,
      inputs?.city || localCities?.destination?.city,
      inputs?.floodZone,
      inputs?.earthquakeZone,
      inputs?.crimeRisk,
      inputs?.coverageAmount,
      inputs?.deductible,
      inputs?.personalPropertyCoverage,
      inputs?.liabilityCoverage,
      inputs?.naturalDisasterCoverage,
      inputs?.occupancyType,
      inputs?.securitySystem,
      inputs?.smokeAlarms,
      inputs?.claimsHistory,
      inputs?.paymentFrequency,
    ];

    // Check if every field is valid (not empty)
    const isAllFilled = requiredFields.every(
      (field) => field !== undefined && field !== null && field !== "",
    );

    if (!isAllFilled) return; // Stop until all fields filled

    // Add 2-second debounce for API call
    const debounceTimer = setTimeout(() => {
      const payload = {
        homeValue: Number(inputs?.homeValue),
        homeType: inputs?.homeType,
        homeSize: Number(inputs?.homeSize),
        yearBuilt: Number(inputs?.yearBuilt),
        constructionType: inputs?.constructionType,
        state: inputs?.state || localCities?.destination?.state?.code,
        city: inputs?.city || localCities?.destination?.city,
        zipCode: inputs.zipCode || "", // Include zipCode if available, otherwise send empty string
        floodZone: inputs?.floodZone,
        earthquakeZone: inputs?.earthquakeZone,
        crimeRisk: inputs?.crimeRisk,
        coverageAmount: Number(inputs?.coverageAmount),
        deductible: Number(inputs?.deductible),
        personalPropertyCoverage: inputs?.personalPropertyCoverage,
        liabilityCoverage: Number(inputs?.liabilityCoverage),
        naturalDisasterCoverage: inputs?.naturalDisasterCoverage,
        occupancyType: inputs?.occupancyType,
        securitySystem: inputs?.securitySystem,
        smokeAlarms: inputs?.smokeAlarms,
        claimsHistory: Number(inputs?.claimsHistory),
        paymentFrequency: inputs?.paymentFrequency,
        page: 1,
        length: 10,
        paginate: false,
      };
      // localStorage.setItem("HomeInsurenceInputs", JSON.stringify(payload));

      dispatch(createHomeInsurance(payload));
    }, 2000); // 2-second debounce

    // Cleanup function to clear timeout if inputs change before 2 seconds
    return () => clearTimeout(debounceTimer);
  }, [inputs, dispatch, localCities]);

  const [locationData, setLocationData] = useState({
    cities: [],
    zipCodes: [],
    loadingCities: false,
    loadingZips: false,
  });

  const fetchZipCodesForCity = useCallback(async (stateCode, cityName) => {
    if (!stateCode || !cityName) return;

    setLocationData((prev) => ({ ...prev, loadingZips: true, zipCodes: [] }));

    try {
      const response = await fetch(
        `https://api.zippopotam.us/us/${stateCode}/${encodeURIComponent(
          cityName,
        )}`,
      );

      if (response.ok) {
        const data = await response.json();
        const zipCodes = data.places
          ? data.places.map((place) => place["post code"]).sort()
          : [];
        setLocationData({ zipCodes, loadingZips: false });
      } else {
        setLocationData({ zipCodes: [], loadingZips: false });
      }
    } catch (error) {
      console.error("Error fetching ZIP codes:", error);
      setLocationData({ zipCodes: [], loadingZips: false });
    }
  }, []);

  // const handleInputChange = useCallback(
  //   (name, value) => {
  //     setInputs((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));

  //     setValue(name, value, { shouldValidate: true });
  //   },
  //   [setInputs, setValue],
  // );

  const handleInputChange = useCallback(
    (name, value) => {
      setInputs((prev) => ({
        ...prev,
        [name]: value,
      }));

      setValue(name, value, { shouldValidate: true });

      const session_id = sessionStorage.getItem("comparison_session_id");
      if (!session_id) return;

      const formatValue = (val) => {
        if (val === undefined || val === null || val === "") return null;

        if (typeof val === "string") {
          return val
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^\w]/g, "_");
        }

        return val;
      };

      const toSnakeCase = (str) => str.replace(/([A-Z])/g, "_$1").toLowerCase();

      if (analyticsDebounceRef.current[name]) {
        clearTimeout(analyticsDebounceRef.current[name]);
      }

      analyticsDebounceRef.current[name] = setTimeout(() => {
        dispatch(
          calculatorAnalytics({
            calculator_type: "home_insurance",
            event_type: "input_adjusted",
            input_name: toSnakeCase(name),
            inputs: formatValue(value),
            results_viewed: true,
            session_id,
            timestamp: new Date().toISOString(),
          }),
        );
      }, 1000);
    },
    [setInputs, setValue, dispatch],
  );
  useEffect(() => {
    if (inputs.state && inputs.city) {
      fetchZipCodesForCity(inputs.state.toLowerCase(), inputs.city.trim());
      handleInputChange("zipCode", "");
    } else {
      setLocationData({ zipCodes: [], loadingZips: false });
      handleInputChange("zipCode", "");
    }
  }, [inputs.state, inputs.city, fetchZipCodesForCity, handleInputChange]);

  const insuranceData = homeStore?.HomeInsuranceItem?.data;

  const basePremium = insuranceData?.breakdown?.basePremium || 0;
  const addons = insuranceData?.breakdown?.addons || 0;
  const fixedExpense = insuranceData?.breakdown?.fixedExpense || 0;
  const profitMargin = insuranceData?.breakdown?.profitMargin || 0;

  const f = insuranceData?.factors || {};

  const multiplier =
    (f.location?.multiplier || 1) *
    (f.construction?.multiplier || 1) *
    (f.age?.multiplier || 1) *
    (f.claims?.multiplier || 1) *
    (f.occupancy?.multiplier || 1);

  const safetyAdjustedMultiplier =
    multiplier * (1 - (f.safety?.safetyDiscount || 0));

  const total =
    (basePremium * safetyAdjustedMultiplier + addons + fixedExpense) *
      (1 + profitMargin) || 0;

  const safeValue = (value, fallback = "-") => {
    return value !== undefined && value !== null && value !== "" ? value : "";
  };

  const buildHomeInsurancePDFPayload = () => ({
    user: {
      full_name: authStore?.user?.full_name ?? "",
      phone: authStore?.user?.phone ?? "",
      email: authStore?.user?.email ?? "",
    },
    inputs: {
      homeValue: inputs.homeValue,
      homeType: inputs.homeType,
      yearBuilt: inputs.yearBuilt,
      constructionType: inputs.constructionType,
      homeSize: inputs.homeSize,
      location: inputs.state,
      city: inputs.city,
      postalCode: inputs.zipCode,
      crimeRisk: inputs.crimeRisk,
      floodZone: inputs.floodZone,
      earthquakeZone: inputs.earthquakeZone,
      coverageAmount: inputs.coverageAmount,
      deductible: inputs.deductible,
      personalPropertyCoverage: inputs.personalPropertyCoverage,
      naturalDisasterCoverage: inputs.naturalDisasterCoverage,
      liabilityCoverage: inputs.liabilityCoverage,
      occupancyType: inputs.occupancyType,
      securitySystem: inputs.securitySystem,
      smokeAlarms: inputs.smokeAlarms,
      claimsHistory: inputs.claimsHistory,
    },
    quoteData: {
      quote: {
        basePremium:
          homeStore?.HomeInsuranceItem?.data?.quote?.basePremium ?? 0,
        annual: homeStore?.HomeInsuranceItem?.data?.quote?.annual ?? 0,
        monthly: homeStore?.HomeInsuranceItem?.data?.quote?.monthly ?? 0,
      },
      factors: homeStore?.HomeInsuranceItem?.data?.factors ?? {},
      breakdown: homeStore?.HomeInsuranceItem?.data?.breakdown ?? {},
    },
  });
  // const downloadPDF = () => {
  //   const payload = buildHomeInsurancePDFPayload();
  //   dispatch(downloadHomePDF(payload));
  // };
  const handleDownloadClick = () => {
    if (planSlug === "free") {
      setShowExportModal(true); // ❌ block
      return;
    }

    downloadPDF(); // ✅ allow
  };
  const downloadPDF = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "home_insurance",
          event_type: "results_downloaded",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }

    const payload = buildHomeInsurancePDFPayload();
    dispatch(downloadHomePDF(payload));
  };
  const sendEmail = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "home_insurance",
          event_type: "quote_shared_via_email",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }
    const subject = "Home Insurance Quote";
    const email = "info@mapmypay.com,";
    const ccEmail = "Tkwells23@gmail.com";

    const quote = homeStore?.HomeInsuranceItem?.data;

    const Mobile = authStore?.user?.phone ?? 0;
    const Customer = authStore?.user?.full_name ?? "";
    const Email = authStore?.user?.email ?? "";

    const body = `
Dear Client,

Your Home Insurance Quote Details:



--------------------------------------------------
| Name | ${Mobile} 
| Phone | ${Customer} 
| Email | ${Email} 
--------------------------------------------------
| Home Value | ${formatCurrency(inputs?.homeValue || 0)} 
| Home Type | ${safeValue(inputs?.homeType)} 
| Year Built | ${safeValue(inputs?.yearBuilt)} 
| Construction | ${safeValue(inputs?.constructionType)} 
| Size | ${safeValue(inputs?.homeSize)} sq ft 
--------------------------------------------------
| State | ${safeValue(inputs?.location)} 
| City | ${safeValue(inputs?.city)} 
| ZIP | ${safeValue(inputs?.postalCode)} 
| Crime Risk | ${safeValue(inputs?.crimeRisk)}
| Flood Zone | ${safeValue(inputs?.floodZone)} 
| Earthquake Zone | ${safeValue(inputs?.earthquakeZone)} 
--------------------------------------------------
| Coverage Amount | ${formatCurrency(inputs?.coverageAmount || 0)} 
| Deductible | ${formatCurrency(inputs?.deductible || 0)} 
| Personal Property | ${safeValue(inputs?.personalPropertyCoverage)} 
| Natural Disaster | ${safeValue(inputs?.naturalDisasterCoverage)} 
| Liability Coverage | ${formatCurrency(inputs?.liabilityCoverage || 0)} 
--------------------------------------------------
| Occupancy Type | ${safeValue(inputs?.occupancyType)} 
| Security System | ${safeValue(inputs?.securitySystem)} 
| Smoke Alarms | ${safeValue(inputs?.smokeAlarms)} 
| Claims History | ${safeValue(inputs?.claimsHistory)} 
--------------------------------------------------
| Base Premium | ${formatCurrency(quote?.quote?.basePremium || 0)} 
| Location Factor | ${safeValue(
      quote?.factors?.location?.multiplier?.toFixed(3),
    )}× 
| Construction Factor | ${safeValue(
      quote?.factors?.construction?.multiplier?.toFixed(3),
    )}× 
| Age Factor | ${safeValue(quote?.factors?.age?.multiplier?.toFixed(3))}× 
| Claims Factor | ${safeValue(quote?.factors?.claims?.multiplier?.toFixed(3))}× 
| Occupancy Factor | ${safeValue(
      quote?.factors?.occupancy?.multiplier?.toFixed(3),
    )}× 
| Safety Discount | ${safeValue(
      (quote?.factors?.safety?.safetyDiscountPercent * 100)?.toFixed(1),
      "0",
    )}% 
| Deductible Adjustment | ${safeValue(
      quote?.breakdown?.deductibleAdjustment?.toFixed(4),
    )}× 
| Add-ons | ${formatCurrency(quote?.breakdown?.addons || 0)} 
| Fixed Expenses | ${formatCurrency(quote?.breakdown?.fixedExpense || 0)} 
| Profit Margin | ${safeValue(
      (quote?.breakdown?.profitMargin * 100)?.toFixed(0),
      "0",
    )}% 
--------------------------------------------------
| Annual Premium | ${formatCurrency(quote?.quote?.annual || 0)} 
| Monthly Premium | ${formatCurrency(quote?.quote?.monthly || 0)} 
--------------------------------------------------

Note:
This is a prototype estimate for demonstration purposes only.
Actual premiums may vary.

Best regards,
Data Pirates Team
`.trim();

    window.location.href = `mailto:${email}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
  };

  const sendEmailCompany = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "home_insurance",
          event_type: "insurance_quote_submitted",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }
    const subject = "Home Insurance Quote";
    const email = "info@mapmypay.com";
    const ccEmail = "Tkwells23@gmail.com";

    const quote = homeStore?.HomeInsuranceItem?.data;

    const Mobile = authStore?.user?.phone ?? 0;
    const Customer = authStore?.user?.full_name ?? "";
    const Email = authStore?.user?.email ?? "";

    const body = `
Dear Client,

Your Home Insurance Quote Details:

--------------------------------------------------
| Name | ${Mobile} 
| Phone | ${Customer} 
| Email | ${Email} 
--------------------------------------------------
| Home Value | ${formatCurrency(inputs?.homeValue || 0)} 
| Home Type | ${safeValue(inputs?.homeType)} 
| Year Built | ${safeValue(inputs?.yearBuilt)} 
| Construction | ${safeValue(inputs?.constructionType)} 
| Size | ${safeValue(inputs?.homeSize)} sq ft 
--------------------------------------------------
| State | ${safeValue(inputs?.location)} 
| City | ${safeValue(inputs?.city)} 
| ZIP | ${safeValue(inputs?.postalCode)} 
| Crime Risk | ${safeValue(inputs?.crimeRisk)} 
| Flood Zone | ${safeValue(inputs?.floodZone)} 
| Earthquake Zone | ${safeValue(inputs?.earthquakeZone)} 
--------------------------------------------------
| Coverage Amount | ${formatCurrency(inputs?.coverageAmount || 0)} 
| Deductible | ${formatCurrency(inputs?.deductible || 0)} 
| Personal Property | ${safeValue(inputs?.personalPropertyCoverage)} 
| Natural Disaster | ${safeValue(inputs?.naturalDisasterCoverage)} 
| Liability Coverage | ${formatCurrency(inputs?.liabilityCoverage || 0)} 
--------------------------------------------------
| Occupancy Type | ${safeValue(inputs?.occupancyType)} 
| Security System | ${safeValue(inputs?.securitySystem)} 
| Smoke Alarms | ${safeValue(inputs?.smokeAlarms)} 
| Claims History | ${safeValue(inputs?.claimsHistory)} 
--------------------------------------------------
| Base Premium | ${formatCurrency(quote?.quote?.basePremium || 0)} 
| Location Factor | ${safeValue(
      quote?.factors?.location?.multiplier?.toFixed(3),
    )}× 
| Construction Factor | ${safeValue(
      quote?.factors?.construction?.multiplier?.toFixed(3),
    )}× 
| Age Factor | ${safeValue(quote?.factors?.age?.multiplier?.toFixed(3))}×
| Claims Factor | ${safeValue(quote?.factors?.claims?.multiplier?.toFixed(3))}× 
| Occupancy Factor | ${safeValue(
      quote?.factors?.occupancy?.multiplier?.toFixed(3),
    )}× 
| Safety Discount | ${safeValue(
      (quote?.factors?.safety?.safetyDiscountPercent * 100)?.toFixed(1),
      "0",
    )}% 
| Deductible Adjustment | ${safeValue(
      quote?.breakdown?.deductibleAdjustment?.toFixed(4),
    )}× 
| Add-ons | ${formatCurrency(quote?.breakdown?.addons || 0)} 
| Fixed Expenses | ${formatCurrency(quote?.breakdown?.fixedExpense || 0)} 
| Profit Margin | ${safeValue(
      (quote?.breakdown?.profitMargin * 100)?.toFixed(0),
      "0",
    )}% 
--------------------------------------------------
| Annual Premium | ${formatCurrency(quote?.quote?.annual || 0)} 
| Monthly Premium | ${formatCurrency(quote?.quote?.monthly || 0)} 
--------------------------------------------------
Best regards,
Map My Pay
`.trim();
    //     window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //       subject
    //     )}&body=${encodeURIComponent(body)}`;
    const mailtoLink =
      `mailto:${encodeURIComponent(email)}` +
      `?cc=${encodeURIComponent(ccEmail)}` +
      `&subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    // 🔥 Check if valid session exists
    if (existingSession && expiry && Date.now() < Number(expiry)) {
      return;
    }

    // const token = localStorage.getItem("authToken");

    // dispatch(
    //   sessionId({
    //     user_id: user.id,
    //     access_token: token,
    //   }),
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        // 🔥 store expiry (important)
        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);
      }
    });
  }, [user]);
  useEffect(() => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    dispatch(
      calculatorAnalytics({
        calculator_type: "home_insurance",
        event_type: "home_insurance_calculator_view",
        session_id,
        timestamp: new Date().toISOString(),
      }),
    );
  }, [dispatch]);
  const handleSaveScenario = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    dispatch(
      calculatorAnalytics({
        calculator_type: "home_insurance",
        event_type: "calculator_scenario_saved",
        session_id,
        timestamp: new Date().toISOString(),
      }),
    );

    localStorage.setItem("HomeInsurenceInputs", JSON.stringify(inputs));
  };
  return (
    <div className="filters-content-main home-insurance-layout">
      <NoIndexSEO title={seoConfig.homeInsurance.title} />
      <Row>
        <div className="filter-sidebar">
          <Card className="filter-container mb-0">
            <div className="inner-sub-sub-title">
              <div className="header-content">
                <div className="inner-sub-title">
                  Home Insurance Quote Generator
                </div>
                <div className="subtitle-text">
                  Fill in your details to get an accurate home insurance quote
                </div>

                {/* Progress Steps - Hidden on mobile when filters closed */}
                {(showFilters || window.innerWidth > 991) && (
                  <div className="progress-steps">
                    <div className={`step ${expandedSections.property || expandedSections.location || expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : ''}`}>
                      <div className={`step-number ${expandedSections.property ? 'active' : (expandedSections.location || expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>1</div>
                      <div className={`step-label ${expandedSections.property ? 'active' : (expandedSections.location || expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>Property</div>
                    </div>
                    <div className={`step ${expandedSections.location || expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : ''}`}>
                      <div className={`step-number ${expandedSections.location ? 'active' : (expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>2</div>
                      <div className={`step-label ${expandedSections.location ? 'active' : (expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>Location</div>
                    </div>
                    <div className={`step ${expandedSections.coverage || expandedSections.security || expandedSections.policy ? 'completed' : ''}`}>
                      <div className={`step-number ${expandedSections.coverage ? 'active' : (expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>3</div>
                      <div className={`step-label ${expandedSections.coverage ? 'active' : (expandedSections.security || expandedSections.policy ? 'completed' : '')}`}>Coverage</div>
                    </div>
                    <div className={`step ${expandedSections.security || expandedSections.policy ? 'completed' : ''}`}>
                      <div className={`step-number ${expandedSections.security ? 'active' : (expandedSections.policy ? 'completed' : '')}`}>4</div>
                      <div className={`step-label ${expandedSections.security ? 'active' : (expandedSections.policy ? 'completed' : '')}`}>Security</div>
                    </div>
                    <div className={`step ${expandedSections.policy ? 'completed' : ''}`}>
                      <div className={`step-number ${expandedSections.policy ? 'active' : ''}`}>5</div>
                      <div className={`step-label ${expandedSections.policy ? 'active' : ''}`}>Policy</div>
                    </div>
                  </div>
                )}
              </div>

              <button
                className="filter-toggle-btn"
                onClick={() => setShowFilters(!showFilters)}
              >
                <FiSliders />
              </button>
            </div>
            <div className={`filter ${showFilters ? "open" : "closed"}`}>
              {/* Property Details Section - Collapsible */}
              <button
                className={`section-header ${expandedSections.property ? 'expanded' : ''}`}
                onClick={() => toggleSection('property')}
              >
                <div className="section-title">
                  <img src={home} alt="home" className="section-icon" />
                  Property Details
                </div>
                <svg
                  className={`chevron ${expandedSections.property ? 'expanded' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </button>

              <div className={`section-content ${!expandedSections.property ? 'collapsed' : ''}`}>
                <div className="sidebar-form">
                  <form>
                  <div className="group-with-error">
                    <div className="form-group three-col-text">
                      <label>Home Value</label>
                      <input
                        {...register("homeValue")}
                        type="number"
                        placeholder="Enter home value"
                        min="50000"
                        step="10000"
                        value={inputs.homeValue}
                        onChange={(e) =>
                          handleInputChange("homeValue", Number(e.target.value))
                        }
                      />
                      <span>$</span>
                    </div>
                    {errors.homeValue && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.homeValue.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Home Type</label>
                      <select
                        value={inputs.homeType}
                        {...register("homeType")}
                        onChange={(e) =>
                          handleInputChange("homeType", e.target.value)
                        }
                      >
                        <option>Apartment</option>
                        <option>Condo</option>
                        <option>Detached</option>
                        <option>Townhouse</option>
                      </select>
                    </div>
                    {errors.homeType && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.homeType.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group three-col-text">
                      <label>Home Size</label>
                      <input
                        type="number"
                        {...register("homeSize")}
                        placeholder="Enter home size"
                        min="100"
                        step="100"
                        value={inputs.homeSize}
                        onChange={(e) =>
                          handleInputChange("homeSize", Number(e.target.value))
                        }
                      />
                      <span>Sq Ft</span>
                    </div>
                    {errors.homeSize && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.homeSize.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Year Built</label>
                      <input
                        type="number"
                        {...register("yearBuilt")}
                        placeholder="Enter year built"
                        min="1900"
                        max={new Date().getFullYear()}
                        value={inputs.yearBuilt}
                        onChange={(e) =>
                          handleInputChange("yearBuilt", Number(e.target.value))
                        }
                      />
                    </div>
                    {errors.yearBuilt && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.yearBuilt.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Construction Type</label>
                      <select
                        value={inputs.constructionType}
                        {...register("constructionType")}
                        onChange={(e) =>
                          handleInputChange("constructionType", e.target.value)
                        }
                      >
                        <option>Wood</option>
                        <option>Brick</option>
                        <option>Concrete</option>
                        <option>Steel</option>
                      </select>
                    </div>
                    {errors.constructionType && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.constructionType.message}
                      </div>
                    )}
                  </div>
                </form>
                </div>
              </div>

              {/* Location Detail Section - Collapsible */}
              <button
                className={`section-header ${expandedSections.location ? 'expanded' : ''}`}
                onClick={() => toggleSection('location')}
              >
                <div className="section-title">
                  <img src={location} alt="location" className="section-icon" />
                  Location Detail
                </div>
                <svg
                  className={`chevron ${expandedSections.location ? 'expanded' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </button>

              <div className={`section-content ${!expandedSections.location ? 'collapsed' : ''}`}>
                <div className="sidebar-form">
                  <form>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>State</label>
                      <select
                        value={localCities?.destination?.state?.code || ""}
                        onChange={(e) => {
                          const selectedCode = e.target.value;
                          const selectedStateObj = selectedCode
                            ? stateOptions.find(
                                (s) => s.code === selectedCode,
                              ) || null
                            : null;

                          setLocalCities((prev) => ({
                            ...prev,
                            destination: {
                              state: selectedStateObj,
                              city: null,
                            },
                          }));
                          handleInputChange("state", selectedCode);
                        }}
                      >
                        <option value="">Select State</option>
                        {stateOptions.map((state) => (
                          <option key={state.code} value={state.code}>
                            {state.label || state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {errors.state && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.state.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>City</label>
                      <select
                        value={localCities?.destination?.city || ""}
                        onChange={(e) => {
                          const selectedCity = e.target.value || null;

                          setLocalCities((prev) => ({
                            ...prev,
                            destination: {
                              ...prev.destination,
                              city: selectedCity,
                            },
                          }));

                          handleInputChange("city", selectedCity);
                        }}
                        disabled={
                          !localCities?.destination?.state ||
                          store.cityItems.loading
                        }
                      >
                        <option value="">
                          {store.cityItems.loading
                            ? "Loading cities..."
                            : !localCities?.destination?.state
                            ? "Select state first"
                            : "Select City"}
                        </option>

                        {store.cityItems?.data?.cities?.map((cityObj) => (
                          <option key={cityObj.city} value={cityObj.city}>
                            {cityObj.city}
                          </option>
                        ))}
                      </select>
                    </div>
                    {errors.city && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.city.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>ZIP Code</label>
                      <select
                        value={inputs.zipCode}
                        onChange={(e) =>
                          handleInputChange("zipCode", e.target.value)
                        }
                        disabled={!inputs.city || locationData.loadingZips}
                      >
                        {locationData.loadingZips ? (
                          <option value="">Loading ZIP codes...</option>
                        ) : !inputs.city ? (
                          <option value="">Select city first</option>
                        ) : locationData.zipCodes.length === 0 ? (
                          <option value="">No ZIP codes found</option>
                        ) : (
                          <option value="">Select ZIP Code</option>
                        )}

                        {locationData.zipCodes.map((zip) => (
                          <option key={zip} value={zip}>
                            {zip}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Flood Zone</label>
                      <select
                        {...register("floodZone")}
                        value={inputs.floodZone}
                        onChange={(e) =>
                          handleInputChange("floodZone", e.target.value)
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    {errors.floodZone && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.floodZone.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Earthquake Zone</label>
                      <select
                        {...register("earthquakeZone")}
                        value={inputs.earthquakeZone}
                        onChange={(e) =>
                          handleInputChange("earthquakeZone", e.target.value)
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                      {errors.earthquakeZone && (
                        <p className="error-text">
                          {errors.earthquakeZone.message}
                        </p>
                      )}
                    </div>
                    {errors.earthquakeZone && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.earthquakeZone.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Crime Risk Level</label>
                      <select
                        {...register("crimeRisk")}
                        value={inputs.crimeRisk}
                        onChange={(e) =>
                          handleInputChange("crimeRisk", e.target.value)
                        }
                      >
                        <option>Low</option>
                        <option>Medium</option>
                        <option>High</option>
                      </select>
                    </div>
                    {errors.crimeRisk && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.crimeRisk.message}
                      </div>
                    )}
                  </div>
                </form>
                </div>
              </div>

              {/* Coverage Options Section - Collapsible */}
              <button
                className={`section-header ${expandedSections.coverage ? 'expanded' : ''}`}
                onClick={() => toggleSection('coverage')}
              >
                <div className="section-title">
                  <img src={coverageOptions} alt="coverage" className="section-icon" />
                  Coverage Options
                </div>
                <svg
                  className={`chevron ${expandedSections.coverage ? 'expanded' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </button>

              <div className={`section-content ${!expandedSections.coverage ? 'collapsed' : ''}`}>
                <div className="sidebar-form">
                  <form>
                  <div className="group-with-error">
                    <div className="form-group three-col-text">
                      <label>Coverage Amount</label>
                      <input
                        {...register("coverageAmount")}
                        type="number"
                        placeholder="Enter coverage"
                        min="50000"
                        step="10000"
                        value={inputs.coverageAmount}
                        onChange={(e) =>
                          handleInputChange(
                            "coverageAmount",
                            Number(e.target.value),
                          )
                        }
                      />
                      <span>$</span>
                    </div>
                    {errors.coverageAmount && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.coverageAmount.message}
                      </div>
                    )}
                  </div>

                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Deductible</label>
                      <select
                        {...register("deductible")}
                        value={inputs.deductible}
                        onChange={(e) =>
                          handleInputChange(
                            "deductible",
                            Number(e.target.value),
                          )
                        }
                      >
                        <option value={500}>$500</option>
                        <option value={1000}>$1,000</option>
                        <option value={2500}>$2,500</option>
                        <option value={5000}>$5,000</option>
                        <option value={10000}>$10,000</option>
                      </select>
                    </div>
                    {errors.deductible && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.deductible.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Personal Property</label>
                      <select
                        {...register("personalPropertyCoverage")}
                        value={inputs.personalPropertyCoverage}
                        onChange={(e) =>
                          handleInputChange(
                            "personalPropertyCoverage",
                            e.target.value,
                          )
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    {errors.personalPropertyCoverage && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.personalPropertyCoverage.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Liability Coverage</label>
                      <select
                        {...register("liabilityCoverage")}
                        value={inputs.liabilityCoverage}
                        onChange={(e) =>
                          handleInputChange(
                            "liabilityCoverage",
                            Number(e.target.value),
                          )
                        }
                      >
                        <option value={100000}>$100,000</option>
                        <option value={300000}>$300,000</option>
                        <option value={500000}>$500,000</option>
                        <option value={1000000}>$1,000,000</option>
                      </select>
                      {errors.liabilityCoverage && (
                        <div
                          className="error-message"
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          {errors.liabilityCoverage.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Natural Disaster</label>
                      <select
                        {...register("naturalDisasterCoverage")}
                        value={inputs.naturalDisasterCoverage}
                        onChange={(e) =>
                          handleInputChange(
                            "naturalDisasterCoverage",
                            e.target.value,
                          )
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    {errors.naturalDisasterCoverage && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.naturalDisasterCoverage.message}
                      </div>
                    )}
                  </div>
                </form>
                </div>
              </div>

              {/* Owner & Security Section - Collapsible */}
              <button
                className={`section-header ${expandedSections.security ? 'expanded' : ''}`}
                onClick={() => toggleSection('security')}
              >
                <div className="section-title">
                  <img src={security} alt="security" className="section-icon" />
                  Owner & Security
                </div>
                <svg
                  className={`chevron ${expandedSections.security ? 'expanded' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </button>

              <div className={`section-content ${!expandedSections.security ? 'collapsed' : ''}`}>
                <div className="sidebar-form">
                  <form>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Occupancy Type</label>
                      <select
                        {...register("occupancyType")}
                        value={inputs?.occupancyType}
                        onChange={(e) =>
                          handleInputChange("occupancyType", e.target.value)
                        }
                      >
                        <option>Owner-occupied</option>
                        <option>Rental</option>
                      </select>
                      {errors.occupancyType && (
                        <p className="error-text">
                          {errors.occupancyType.message}
                        </p>
                      )}
                    </div>
                    {errors.occupancyType && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.occupancyType.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Security System</label>
                      <select
                        {...register("securitySystem")}
                        value={inputs.securitySystem}
                        onChange={(e) =>
                          handleInputChange("securitySystem", e.target.value)
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    {errors.securitySystem && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.securitySystem.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Smoke/Fire Alarms</label>
                      <select
                        {...register("smokeAlarms")}
                        value={inputs.smokeAlarms}
                        onChange={(e) =>
                          handleInputChange("smokeAlarms", e.target.value)
                        }
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                    {errors.smokeAlarms && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.smokeAlarms.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group three-col-label">
                      <label>Claims History</label>
                      <input
                        {...register("claimsHistory")}
                        type="number"
                        placeholder="0"
                        min="0"
                        max="10"
                        value={inputs.claimsHistory}
                        onChange={(e) =>
                          handleInputChange(
                            "claimsHistory",
                            Number(e.target.value),
                          )
                        }
                      />
                      <span>Claims</span>
                    </div>
                    {errors.claimsHistory && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.claimsHistory.message}
                      </div>
                    )}
                  </div>
                </form>
                </div>
              </div>

              {/* Policy Preferences Section - Collapsible */}
              <button
                className={`section-header ${expandedSections.policy ? 'expanded' : ''}`}
                onClick={() => toggleSection('policy')}
              >
                <div className="section-title">
                  <img src={policy} alt="policy" className="section-icon" />
                  Policy Preferences
                </div>
                <svg
                  className={`chevron ${expandedSections.policy ? 'expanded' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </button>

              <div className={`section-content ${!expandedSections.policy ? 'collapsed' : ''}`}>
                <div className="sidebar-form">
                  <form>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Payment Frequency</label>
                      <select
                        {...register("paymentFrequency")}
                        value={inputs.paymentFrequency}
                        onChange={(e) =>
                          handleInputChange("paymentFrequency", e.target.value)
                        }
                      >
                        <option>Monthly</option>
                        <option>Annual</option>
                      </select>
                    </div>
                    {errors.paymentFrequency && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.paymentFrequency.message}
                      </div>
                    )}
                  </div>
                  <div className="group-with-error">
                    <div className="form-group two-col">
                      <label>Coverage Term</label>
                      <select
                        {...register("coverageTerm")}
                        value={inputs.coverageTerm}
                        onChange={(e) =>
                          handleInputChange("coverageTerm", e.target.value)
                        }
                      >
                        <option value="1">1 Year</option>
                        <option value="2">2 Years</option>
                        <option value="3">3 Years</option>
                        <option value="5">5 Years</option>
                      </select>
                      {errors.coverageTerm && (
                        <div
                          className="error-message"
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          {errors.coverageTerm.message}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
                </div>
              </div>
            </div>
          </Card>
        </div>

        <div className="filter-content">
          <div className="home-insurance-cards">
            {/* Premium Card */}
            <div className="premium-card">
              {/* Premium Summary with gradient background */}
              <div className="premium-summary-card">
                <div className="premium-header">
                  <div className="premium-info">
                    <h3>Your Estimated Premium</h3>
                    <p>(Monthly)</p>
                    <div className="premium-amount">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.monthly || 0)}
                    </div>
                    <div className="premium-breakdown-text">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.annual || 0)} / Yearly
                    </div>
                  </div>
                  <div className="shield-icon">
                    <img src={require("../../../assets/images/home-security.svg").default} alt="Home Shield" />
                  </div>
                </div>
              </div>

              {/* Details Grid */}
              <div className="details-grid">
                <div className="detail-item">
                  <div className="detail-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1.9.74 1.77 2.65 1.77 2.22 0 2.84-.97 2.84-1.77 0-1.03-.92-1.5-3.01-2.51-2.31-1.11-3.83-2.07-3.83-4.17 0-1.47 1.22-2.79 3.23-3.24V3h2.67v1.8c2.83.48 2.96 2.68 2.96 2.68h-1.93c0-.66-.43-1.39-2.03-1.39-1.78 0-2.49.56-2.49 1.58 0 .78.49 1.24 2.68 2.09 2.19.85 4.16 1.99 4.16 4.58 0 1.82-1.39 3.16-3.92 3.75z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Premium</div>
                    <div className="detail-value">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.monthly || 0)}
                    </div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Annual Premium</div>
                    <div className="detail-value">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.annual || 0)}
                    </div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <img src={security} alt="Coverage" />
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Coverage Amount</div>
                    <div className="detail-value">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.coverageAmount || 0)}
                    </div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <img src={policy} alt="Deductible" />
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Deductible</div>
                    <div className="detail-value">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.deductible || 0)}
                    </div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <img src={home} alt="Home Type" />
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Home Type</div>
                    <div className="detail-value">{inputs.homeType || "N/A"}</div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <img src={coverageOptions} alt="Rebuild Cost" />
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Rebuild Cost</div>
                    <div className="detail-value">
                      {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.rebuildCost || 0)}
                    </div>
                  </div>
                </div>

                <div className="detail-item">
                  <div className="detail-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="detail-content">
                    <div className="detail-label">Base Rate</div>
                    <div className="detail-value">
                      {((homeStore?.HomeInsuranceItem?.data?.breakdown?.baseRate || 0) * 100).toFixed(2)}%
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <button
                  className="btn-submit-quote"
                  disabled={homeStore?.HomeInsuranceItem?.data ? false : true}
                  onClick={sendEmailCompany}
                >
                  <Submit />
                  Submit Quote
                </button>

                <div className="secondary-actions">
                  <button
                    className="btn-secondary-action"
                    disabled={homeStore?.HomeInsuranceItem?.data ? false : true}
                    onClick={handleSaveScenario}
                  >
                    <Save />
                    Save Draft
                  </button>

                  <button
                    className="btn-secondary-action"
                    disabled={homeStore?.HomeInsuranceItem?.data ? false : true}
                    onClick={handleDownloadClick}
                  >
                    <Download />
                    Download PDF
                  </button>

                  <button
                    className="btn-secondary-action"
                    disabled={homeStore?.HomeInsuranceItem?.data ? false : true}
                    onClick={sendEmail}
                  >
                    <Mail />
                    Send via Email
                  </button>
                </div>
              </div>
            </div>

            {/* Premium Breakdown Card */}
            <div className="breakdown-card">
              <div className="card-header" onClick={() => setShowBreakdown(!showBreakdown)}>
                <div className="card-title">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" fill="currentColor"/>
                  </svg>
                  Premium Breakdown
                </div>
                <svg
                  className={`chevron ${showBreakdown ? 'expanded' : ''}`}
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                </svg>
              </div>

              {showBreakdown && (
                <div className="card-content">
                  <div className="breakdown-table-container">
                    <div className="breakdown-table">
                      <div className="breakdown-header">
                        <div className="header-item">Component</div>
                        <div className="header-item center">Value</div>
                        <div className="header-item">Impact</div>
                      </div>
                      <div className="breakdown-row">
                        <div className="component">Base Premium</div>
                        <div className="value">
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.breakdown?.basePremium || 0)}
                        </div>
                        <div className="impact">
                          Coverage × Base Rate ({((homeStore?.HomeInsuranceItem?.data?.breakdown?.baseRate || 0) * 100).toFixed(3)}%)
                        </div>
                      </div>

                      {/* Risk Multipliers Section Header */}
                      <div className="breakdown-row" style={{ background: 'var(--mmp-hover-bg)', fontWeight: '600' }}>
                        <div className="component" style={{ gridColumn: '1 / -1' }}>Risk Multipliers Applied:</div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">M_loc (Location)</div>
                        <div className="value">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.location?.multiplier || 0}×
                        </div>
                        <div className="impact">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.location?.floodZone === "Yes" ? "Flood, " : ""}
                          {homeStore?.HomeInsuranceItem?.data?.factors?.location?.earthquakeZone === "Yes" ? "EQ, " : ""}
                          Crime: {homeStore?.HomeInsuranceItem?.data?.factors?.location?.crimeRisk || "-"}
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">M_const (Construction)</div>
                        <div className="value">
                          {(homeStore?.HomeInsuranceItem?.data?.factors?.construction?.multiplier || 0).toFixed(3)}×
                        </div>
                        <div className="impact">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.construction?.type || "N/A"}
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">M_age (Age)</div>
                        <div className="value">
                          {(homeStore?.HomeInsuranceItem?.data?.factors?.age?.multiplier || 0).toFixed(3)}×
                        </div>
                        <div className="impact">
                          {new Date().getFullYear() - (inputs.yearBuilt || new Date().getFullYear())} years
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">M_claims (Claims)</div>
                        <div className="value">
                          {(homeStore?.HomeInsuranceItem?.data?.factors?.claims?.multiplier || 0).toFixed(3)}×
                        </div>
                        <div className="impact">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.claimsHistory || 0} claims
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">M_occup (Occupancy)</div>
                        <div className="value">
                          {(homeStore?.HomeInsuranceItem?.data?.factors?.occupancy?.multiplier || 0).toFixed(3)}×
                        </div>
                        <div className="impact">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.occupancy?.occupancyType || "N/A"}
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">Safety Discount</div>
                        <div className="value">
                          {((homeStore?.HomeInsuranceItem?.data?.factors?.safety?.safetyDiscountPercent || 0) * 100).toFixed(1)}%
                        </div>
                        <div className="impact">
                          {homeStore?.HomeInsuranceItem?.data?.factors?.safety?.securitySystem === "Yes" ? "Security (8%), " : ""}
                          {homeStore?.HomeInsuranceItem?.data?.factors?.safety?.smokeAlarms === "Yes" ? "Alarms (5%)" : ""}
                        </div>
                      </div>

                      {/* Additional Components Section Header */}
                      <div className="breakdown-row" style={{ background: 'var(--mmp-hover-bg)', fontWeight: '600' }}>
                        <div className="component" style={{ gridColumn: '1 / -1' }}>Additional Components:</div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">Add-ons</div>
                        <div className="value">
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.breakdown?.addons || 0)}
                        </div>
                        <div className="impact">
                          Personal Property, Liability, Natural Disaster, Term Discount
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">Fixed Expense</div>
                        <div className="value">
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.breakdown?.fixedExpense || 0)}
                        </div>
                        <div className="impact">
                          Administrative costs
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">Profit Margin</div>
                        <div className="value">
                          {((homeStore?.HomeInsuranceItem?.data?.breakdown?.profitMargin || 0) * 100).toFixed(0)}%
                        </div>
                        <div className="impact">
                          Markup
                        </div>
                      </div>

                      <div className="breakdown-row">
                        <div className="component">D_adj (Deductible)</div>
                        <div className="value">
                          {(homeStore?.HomeInsuranceItem?.data?.breakdown?.deductibleAdjustment || 0).toFixed(4)}×
                        </div>
                        <div className="impact">
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.deductible || 0)} deductible
                        </div>
                      </div>

                      <div className="breakdown-total">
                        <div className="component">Annual Premium</div>
                        <div className="value">
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.annual || 0)}
                        </div>
                        <div className="impact">Total yearly cost</div>
                      </div>

                      <div className="breakdown-row" style={{ background: 'var(--mmp-accent-bg)', borderTop: '2px solid var(--mmp-accent)' }}>
                        <div className="component" style={{ fontWeight: '600', color: 'var(--mmp-accent)' }}>Monthly Premium</div>
                        <div className="value" style={{ fontWeight: '700', color: 'var(--mmp-accent)' }}>
                          {formatCurrency(homeStore?.HomeInsuranceItem?.data?.quote?.monthly || 0)}
                        </div>
                        <div className="impact" style={{ fontWeight: '600', color: 'var(--mmp-accent)' }}>Your payment amount</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <PaywallSheet
            show={showExportModal}
            onCancel={() => setShowExportModal(false)}
          />
        </div>
      </Row>
    </div>
  );
};

export default HomeInsurance;
